import { extractCypressLocatorDataCyAttribute } from "./extractCypressLocatorDataCyAttribute";
export function getCypressLocatorAttributesIfConditionsMet(condition, props) {
    if (condition) {
        return extractCypressLocatorDataCyAttribute(props);
    }
    return {};
}
//# sourceMappingURL=getCypressLocatorAttributesIfConditionsMet.js.map